import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { EditalCota, EditalCotaRequest } from '@/models';

@Injectable({
  providedIn: 'root',
})
export class EditalCotaService {
  private baseUrl = `${environment.apiUrl}/admin/editais`;

  constructor(private http: HttpClient) {}

  getCotasAtivas(editalId: number): Observable<EditalCota[]> {
    return this.http.get<EditalCota[]>(`${this.baseUrl}/${editalId}/cotas/ativas`);
  }

  vincularCota(editalId: number, data: EditalCotaRequest): Observable<EditalCota> {
    return this.http.post<EditalCota>(`${this.baseUrl}/${editalId}/cotas`, data);
  }

  atualizarCota(editalId: number, editalCotaId: number, data: EditalCotaRequest): Observable<EditalCota> {
    return this.http.put<EditalCota>(`${this.baseUrl}/${editalId}/cotas/${editalCotaId}`, data);
  }

  removerCota(editalId: number, editalCotaId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${editalId}/cotas/${editalCotaId}`);
  }
}
